// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"NavMenu_sidebar__3NeRh","logo":"NavMenu_logo__4HQpA","sidebarIndicator":"NavMenu_sidebarIndicator__wj4uZ","sidebarNavs":"NavMenu_sidebarNavs__NJ89Z"};